"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const value = schema_1.Schema.number()
    .unit("pg/ml")
    .integer()
    .min(0)
    .max(50000)
    .interpretation({ vocab: "ltx", code: "NT-proBNP" })
    .tag({ vocab: "loinc", code: "33762-6" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
